var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pencil_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 0.121569 0 0 0 0 0.690196 0 0 0 0 0.968627 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#pencil_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 4.667
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.799 9.168a4.652 4.652 0 0 1 1.367 3.3 4.652 4.652 0 0 1-1.367 3.3L20.945 42.62l-10.311.412.412-10.312L37.899 5.868A4.652 4.652 0 0 1 41.2 4.5c1.195 0 2.389.455 3.3 1.367ZM31.3 9.168l13.2 13.2"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M2.333 51.333h51.333V56H2.333z"
  }))));
};
export default SvgPencil;